import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment, { min } from 'moment';
import * as files from '../../fileUtils';
import { find, head } from 'lodash';
import { validationMixin } from 'vuelidate';
import { required, integer, minValue, numeric } from 'vuelidate/lib/validators';

const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'receipting',
  mixins: [validationMixin],
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    reportsComp: require('../../common/reports/reports.vue').default
  },
  data: function () {
    return {
      tabUniqueId: 0,
      uniqueIdTimer: '',
      windowInaccessible: false,

      billingGroups: [],
      billingGroup: null,
      consumerTypes: [],
      consumerType: '',
      accountNo: '',
      filter: '',
      pageIndex: 1,
      pageSize: 10,
      customers: [],
      customerCount: 0,
      options: { pageSize: 10, total: 0, page: 1 },
      customersCols: [],
      lang: '',
      keyColumn: 'account',
      customer: {
        account: '',
        balance: 0,
        billingGroup: '',
        consumerType: '',
        address: '',
        name: '',
        telNo: '',
        cellTelNo: '',
        workTelNo: '',
        email: ''
      },

      active: '',
      stepSelectCustomer: false,
      stepReceipting: false,
      stepPaymentProcessing: false,

      newreceipt: {},

      showAllPaymentTypes: true,
      showAllPaymentTypesDisable: true,
      transactionTypes: [],
      transactionType: '',
      charges: '',

      pendingApplications: [],
      applicationsTypes: [],
      applicationsType: 0,
      applicationType: 0,

      properties: [],
      propertyId: 0,

      isOwner: true,
      amountToBePaid: 0,
      memo: '',
      comment: '',
      runningTotal: 0,

      selectedSubReceiptIdx: 0,
      selectedSubReceipt: {},

      cash: 0,
      cheque: 0,
      cashEnable: true,
      chequeEnable: false,
      creditCard: 0,
      creditCardEnable: false,
      secondCash: 0,
      secondCashEnable: false,

      terminationDate: null,

      showCustomerDetailsDialog: false,

      showDialog: false,

      deleteTransShowConfirm: false,
      deleteTransIndex: -1,
      deleteTransMessage: '',

      settings: {
        canCloseSession: false,
        canVoidReceipt: false,
        consumerTypes: [],
        banks: []
      },
      session: {
        sessionId: -1,
        receiptCount: 0,
        fromReceiptNo: '',
        toReceiptNo: '',
        nextReceiptNo: '',
        isFinalReceipt: false
      },
      receiptFrom: '',
      receiptTo: '',
      cashierId: -1,
      sessionId: -1,

      cashier: {},

      receiptReports: [],

      customerValidated: null,
      customerProperties: null,
      customerTransactionTypes: null,
      applicationPendingCharges: null,
      receiptSaved: null,
      receiptReportUrl: '',
      voidReceiptNo: '',
      bSuspended: false,
      bClosed: false,

      amountPaid: 0,
      change: 0,

      saveReceiptDone: false,

      newSessionWindow: false,
      resumeSessionWindow: false,

      newSession: {
        startReceiptNo: null,
        endReceiptNo: null,
        cashierFloat: 0
      },

      suspendedSession: {},
      suspendSessionShowConfirm: false,
      showCloseSessionsDialog: false,

      closeSession: {
        bankRef: '',
        totalCash: 0,
        totalCheques: 0,
        totalCreditCard: 0,
        totalAmount: 0
      },

      showVoidReceiptDialog: false,
      voidReceiptData: {
        receiptNo: '',
        receiptAmt: 0,
        comment1: '',
        comment2: ''
      },

      latestReceiptNo: '',
      showCancelReceiptDialog: false,
      currentReceiptNo: '',

      attachments: [],
      selectedAttachments: [],

      paymantAttachmentsActiveTab: 'tab-payment',
      cashPaidAmount: 0,

      totalAmountToPay: {
        cash: 0,
        cheque: 0,
        creditCard: 0,
        total: 0
      },
      overAmount: {
        cash: 0,
        cheque: 0,
        creditCard: 0,
        total: 0
      },
      totalAmountPaid: 0,
      generalReports: [],
      showGeneralReports: false,
      repUrl: '',
      elementVisible: false,
      showReceiptCopyReports: false,
      receiptCopyReports: [],
      printCopyReceiptNo: '',
      queries: []
    };
  },
  validations: {
    newSession: {
      startReceiptNo: {
        required,
        integer
      },
      endReceiptNo: {
        required,
        integer
      },
      cashierFloat: {
        required,
        numeric,
        minValue: minValue(0)
      }
    },
    newreceipt: {
      subReceipts: {
        $each: {
          ReceiptAmount: {
            required,
            minValue: minValue(0.01)
          }
        }
      },
      chequeAmount: {
        minValue: minValue(0)
      },
      postalAmount: {
        minValue: minValue(0)
      }
    },
    totalAmountPaid: {
      minValue: minValue(0)
    },
    cashPaidAmount: {
      minValue: minValue(0)
    }
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    },
    getLatestReceiptNo: {
      get() {
        if (this.session.nextReceiptNo == this.session.fromReceiptNo) return this.session.nextReceiptNo;

        var nxtReceiptNo = (Number(this.session.nextReceiptNo) - 1).toString();

        var zero = '';
        for (var i = 0; i < this.session.fromReceiptNo.length - nxtReceiptNo.length; i++) {
          zero += '0';
        }

        nxtReceiptNo = zero + nxtReceiptNo.toString();

        return nxtReceiptNo;
      }
    },
    balanceAfterPayment: function () {
      return this.customer.balance - this.amountPaid;
    }
  },
  watch: {
    languageLocale: function (value) {},
    active: function (value) {
      if (value == 'stepSelectCustomer') {
        this.createNewReceipt();
        this.stepSelectCustomer = false;
        this.stepReceipting = false;
        this.stepPaymentProcessing = false;
      } else if (value == 'stepReceipting') {
        this.stepReceipting = false;
        this.stepPaymentProcessing = false;

        this.chequeEnable = false;
        this.creditCardEnable = false;
        this.newreceipt.cashAmount = 0;
        this.newreceipt.chequeAmount = 0;
        this.newreceipt.postalAmount = 0;
        this.amountPaid = 0;
        this.runningTotal = 0;

        this.totalAmountToPay.cash = 0;
        this.totalAmountToPay.cheque = 0;
        this.totalAmountToPay.creditCard = 0;
        this.totalAmountToPay.total = 0;
        this.overAmount.cash = 0;
        this.overAmount.cheque = 0;
        this.overAmount.creditCard = 0;
        this.overAmount.total = 0;
      }
    },
    transactionType: function (value) {
      this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransCode = value.split('-')[0];
      this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransSubCode = value.split('-')[1];

      var trans = this.transactionTypes.filter((a) => a.transCode == value.split('-')[0] && a.transSubCode == value.split('-')[1])[0];

      var pendingApp = this.pendingApplications.filter((a) => a.chargeCode == trans.chargeTransCode && a.chargeSubCode == trans.chargeTransSubCode);

      if (pendingApp.length == 0) {
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ApplicationId = 0;
        this.applicationType = 0;
      } else {
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ApplicationId = pendingApp[0].applicationId;
        this.applicationType = pendingApp[0].applicationId;
      }
    },
    applicationType: function (value) {
      this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ApplicationId = value;

      if (value != 0) {
        var app = this.pendingApplications.filter((a) => a.applicationId == this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ApplicationId)[0];

        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransCode = this.transactionTypes.filter(
          (a) => a.chargeTransCode == app.chargeCode && a.chargeTransSubCode == app.chargeSubCode
        )[0].transCode;
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransSubCode = this.transactionTypes.filter(
          (a) => a.chargeTransCode == app.chargeCode && a.chargeTransSubCode == app.chargeSubCode
        )[0].transSubCode;

        this.transactionType =
          this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransCode +
          '-' +
          this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransSubCode;

        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ReceiptAmount = app.amount;
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ActivityId = app.activityId;
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ChargeTransCode = app.chargeCode;
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ChargeTransSubCode = app.chargeSubCode;
      } else {
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ReceiptAmount = 0;
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ActivityId = 0;
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ChargeTransCode = 0;
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ChargeTransSubCode = 0;
      }
    },
    selectedSubReceipt: {
      handler: function () {
        this.runningTotal = 0;

        for (var i = 0; i < this.newreceipt.subReceipts.length; i++) {
          this.newreceipt.subReceipts[i].ReceiptAmount = Number(this.newreceipt.subReceipts[i].ReceiptAmount);
          this.runningTotal += Number(this.newreceipt.subReceipts[i].ReceiptAmount);
        }
      },
      deep: true
    },
    //newreceipt: {
    //  handler: function () {
    //    this.calcPaidAmount();
    //  },
    //  deep: true
    //},
    closeSession: {
      handler(val) {
        this.calcCloseSessionTotalAmount();
      },
      deep: true
    }
  },
  created() {
    //this.GetReceiptingUniqueId();
    this.InitReceiptingUniqueId();
    this.getSettings();
    //this.getCashierDetails();
    //await this.getOpenOrResumeSession();
    //this.getBillingGroups();
    this.fillCustomersCols();
    this.getReceiptingGeneralReports();
    this.getReceiptCopyReports();
    this.getQueries();
  },
  beforeDestroy() {
    clearInterval(this.uniqueIdTimer);
    //window.removeEventListener('beforeunload', this.suspendSession);
  },
  methods: {
    getValidationClass(obj, fieldName) {
      let field = null;

      if (obj == '') field = this.$v[fieldName];
      else field = this.$v[obj][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        };
      }
    },
    getValidationClass2(obj, subObj, fieldName, index) {
      const field = this.$v[obj][subObj].$each[index][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        };
      }
    },
    InitReceiptingUniqueId() {
      return axios
        .post('/Receipting/InitReceiptingUniqueId')
        .then((response) => {
          if (response.status == 200) {
            this.tabUniqueId = response.data;
            this.uniqueIdTimer = setInterval(this.GetReceiptingUniqueId, 60000);
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    GetReceiptingUniqueId() {
      return axios
        .post('/Receipting/GetReceiptingUniqueId')
        .then((response) => {
          if (response.status === 200) {
            if (this.tabUniqueId != response.data) {
              this.windowInaccessible = true;
              clearInterval(this.uniqueIdTimer);
            }
          }

          //&& response.data.data.status === 0)
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getSettings() {
      return axios
        .get('/Receipting/GetSettings')
        .then((response) => {
          if (response.status == 200) {
            this.settings = response.data;

            this.consumerTypes = this.settings.consumerTypes;

            if (this.consumerTypes.length > 0) this.consumerType = this.consumerTypes[0].id;
          }
        })
        .then((a) => {
          this.getCashierDetails();
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getCashierDetails() {
      axios
        .post('/Receipting/GetCashierDetails')
        .then((response) => {
          if (response.status == 200) this.cashier = response.data;
        })
        .then((a) => {
          this.getBillingGroups();
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getOpenOrResumeSession() {
      this.newSessionWindow = false;
      this.resumeSessionWindow = false;

      this.$store.state.notifier.asyncBlock(
        axios.post('/Receipting/GetOpenOrResumeSession'),
        (response) => {
          if (response.status == 200) {
            if (response.data.sessionId == -1) {
              this.$v.newSession.$reset();
              this.newSessionWindow = true;

              if (this.settings.showCashierReceiptRange) this.getNewSessionParameters();
            } else {
              if (response.data.toBeClosed) {
                this.closeSession.totalCash = 0;
                this.closeSession.totalCheques = 0;
                this.closeSession.totalCreditCard = 0;

                this.showCloseSessionsDialog = true;
              } else {
                this.resumeSessionWindow = true;
                this.suspendedSession = response.data;
              }
            }
          } else if (response.status == 204) {
            this.$v.newSession.$reset();
            this.newSessionWindow = true;

            if (this.settings.showCashierReceiptRange) this.getNewSessionParameters();
          }
        },
        (err) => {
          this.$alertMsg(err.response.data);
        }
      );
    },
    getBillingGroups() {
      axios
        .post('/Receipting/GetBillingGroups')
        .then((response) => {
          if (response.status == 200) {
            this.billingGroups = response.data;

            if (this.billingGroups.length > 0) this.billingGroup = this.billingGroups[0].id;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getCustomers() {
      this.cancelSelection();

      this.$store.state.notifier.asyncBlock(
        axios.post(
          '/Receipting/GetCustomers?' +
            'billingGroupId=' +
            this.billingGroup +
            '&consumerTypeId=' +
            this.consumerType +
            '&filterAccount=' +
            this.accountNo +
            '&filter=' +
            this.filter +
            '&includeBalance=false' +
            '&pageIndex=' +
            this.options.page +
            '&pageSize=' +
            this.options.pageSize
        ),
        (response) => {
          if (response.status == 200) {
            this.customers = response.data.items;
            this.options.total = response.data.totalCount;
            this.customerCount = response.data.totalCount;

            if (this.customers.length == 0) {
              this.$alertMsg(this.$t('receipting.noDataFound'));
            }
          }
        },
        (error) => {
          this.$alertMsg(error.response.data);
        }
      );
    },
    resetFilters() {
      this.billingGroup = '';
      this.consumerType = '';
      this.accountNo = '';
      this.filter = '';
    },
    pageChange(pInfo) {
      if (this.options.page == pInfo.pageNumber && this.options.pageSize == pInfo.pageSize) return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getCustomers();
    },
    fillCustomersCols() {
      this.customersCols.push({ dataField: 'billingGroup', caption: this.$t('receipting.billingGroup') });
      this.customersCols.push({ dataField: 'account', caption: this.$t('receipting.accountNo') });
      this.customersCols.push({ dataField: 'name', caption: this.$t('receipting.surname') });
      this.customersCols.push({ dataField: 'mailAddress', caption: this.$t('receipting.address') });
      this.customersCols.push({ dataField: 'consumerType', caption: this.$t('receipting.consumerType') });
      this.customersCols.push({ dataField: 'active', caption: this.$t('receipting.status'), dataType: 'boolean' });
    },
    chooseCustomer(info) {
      if (info.newRowIndex < 0) return;

      var cust = info.rows[info.newRowIndex].data;
      if (cust === null || cust === undefined) return;

      this.customer.account = cust.account;

      this.validateCustomer();
    },
    cancelSelection() {
      this.customer.account = '';
      this.customer.balance = '';
      this.customer.billingGroup = '';
      this.customer.consumerType = '';
      this.customer.address = '';
      this.customer.name = '';
      this.telNo = '';
      this.cellTelNo = '';
      this.workTelNo = '';
      this.email = '';

      this.showCustomerDetailsDialog = false;
    },
    async selectCustomer() {
      this.showCustomerDetailsDialog = false;

      //await this.createNewReceipt();
      await this.getCustomerTransactionTypes();
      await this.getCustomerProperties();

      if (this.pendingApplications.length > 1) {
        var pendingApps = this.pendingApplications.filter((a) => a.applicationId != 0);
        for (var i = 0; i < pendingApps.length; i++) {
          if (
            this.transactionTypes.filter(
              (a) => a.chargeTransCode == pendingApps[i].chargeCode && a.chargeTransSubCode == pendingApps[i].chargeSubCode
            ).length == 0
          ) {
            this.$alertMsg(this.$t('receipting.OperationIsCancelled'));
            return;
          }

          this.newreceipt.subReceipts.push({
            Account: this.customer.account,
            TransCode: Number(
              this.transactionTypes.filter(
                (a) => a.chargeTransCode == pendingApps[i].chargeCode && a.chargeTransSubCode == pendingApps[i].chargeSubCode
              )[0].transCode
            ),
            TransSubCode: Number(
              this.transactionTypes.filter(
                (a) => a.chargeTransCode == pendingApps[i].chargeCode && a.chargeTransSubCode == pendingApps[i].chargeSubCode
              )[0].transSubCode
            ),
            ChargeTransCode: Number(pendingApps[i].chargeCode),
            ChargeTransSubCode: Number(pendingApps[i].chargeSubCode),
            PropertyOwner: true,
            PropertyReconnection: false,
            PropertyId: this.properties.length > 0 ? this.properties[0].propertyId : null,
            ReceiptAmount: pendingApps[i].amount,
            Remarks1: '',
            Remarks2: '',
            DmCaseId: 0,
            AgreemNo: 0,
            ApplicationId: pendingApps[i].applicationId,
            ActivityId: pendingApps[i].activityId
          });
        }

        this.transactionType = this.newreceipt.subReceipts[0].TransCode + '-' + this.newreceipt.subReceipts[0].TransSubCode;
        this.selectedSubReceiptIdx = 0;
        this.selectedSubReceipt = this.newreceipt.subReceipts[0];
        this.applicationType = this.newreceipt.subReceipts[0].ApplicationId;
      } else {
        var tt = this.transactionTypes[0];
        this.newreceipt.subReceipts.push({
          Account: this.customer.account,
          TransCode: Number(tt.transCode),
          TransSubCode: Number(tt.transSubCode),
          ChargeTransCode: Number(tt.chargeTransCode),
          ChargeTransSubCode: Number(tt.chargeTransSubCode),
          PropertyOwner: true,
          PropertyReconnection: false,
          PropertyId: this.properties.length > 0 ? this.properties[0].propertyId : null,
          ReceiptAmount: 0,
          Remarks1: '',
          Remarks2: '',
          DmCaseId: 0,
          AgreemNo: 0,
          ApplicationId: 0,
          ActivityId: 0
        });

        this.transactionType = this.newreceipt.subReceipts[0].TransCode + '-' + this.newreceipt.subReceipts[0].TransSubCode;
        this.selectedSubReceiptIdx = 0;
        this.selectedSubReceipt = this.newreceipt.subReceipts[0];
        this.applicationType = this.newreceipt.subReceipts[0].ApplicationId;
      }

      this.setDone('stepSelectCustomer', 'stepReceipting');
    },
    validateCustomer() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/Receipting/ValidateCustomer?account=' + this.customer.account),
        (response) => {
          if (response.status == 200) {
            this.customer.billingGroup = response.data.billingGroup;
            this.customer.consumerType = response.data.consumerType;
            this.customer.address = response.data.mailAddress;
            this.customer.name = response.data.name;
            this.customer.balance = response.data.balance;
            this.customer.telNo = response.data.telNo;
            this.customer.cellTelNo = response.data.cellTelNo;
            this.customer.workTelNo = response.data.workTelNo;
            this.customer.email = response.data.email;

            this.customerValidated = response.data.item;

            this.showCustomerDetailsDialog = true;
          }
        },
        (error) => {
          this.$alertMsg(error.response.data);
        }
      );
    },
    setDone(id, index) {
      this[id] = true;

      if (index) {
        this.active = index;
      }
    },
    createNewReceipt() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/Receipting/CreateNewReceipt'),
        (response) => {
          if (response.status == 200) {
            this.newreceipt = response.data;
            var nxtReceiptNo = Number(this.newreceipt.receiptNo).toString();

            var zero = '';
            for (var i = 0; i < this.session.fromReceiptNo.length - nxtReceiptNo.length; i++) {
              zero += '0';
            }

            nxtReceiptNo = zero + nxtReceiptNo.toString();

            this.session.nextReceiptNo = nxtReceiptNo;
          }
        },
        (error) => {
          this.$alertMsg(error.response.data);
        }
      );
    },
    getCustomerTransactionTypes() {
      return axios
        .post('/Receipting/GetCustomerTransactionTypes?account=' + this.customer.account)
        .then((response) => {
          if (response.status == 200) {
            this.transactionTypes = response.data.items;
            var apps = response.data.applicationPendingCharges;
            this.fillPendingApplicationsList(apps);
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    fillPendingApplicationsList(apps) {
      this.pendingApplications = [];
      this.applicationsTypes = [];
      this.applicationsType = 0;

      this.pendingApplications.push({
        activityId: 0,
        amount: 0,
        applicationId: 0,
        chargeCode: 0,
        chargeSubCode: 0,
        name: this.$t('receipting.notLinkedToAnApplication')
      });

      for (var i = 0; i < apps.length; i++) {
        //if (this.customer.account == '106197679') {
        //  apps[i].chargeCode = 20;
        //}

        this.pendingApplications.push(apps[i]);
      }

      if (this.pendingApplications.length == 1) this.applicationsType = 0;
      else {
        this.applicationsType = this.pendingApplications.filter((a) => a.applicationId != 0)[0].applicationId;
      }
    },
    getCustomerProperties() {
      return axios
        .post(
          '/Receipting/GetCustomerProperties?' +
            'account=' +
            this.customer.account +
            '&owner=' +
            (this.ownerTenant == 'owner' ? true : false) +
            '&reconnection=false'
        )
        .then((response) => {
          if (response.status == 200) {
            this.properties = response.data;

            if (this.properties.length > 0) this.propertyId = this.properties[0].propertyId;
            else this.propertyId = 0;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    fillSubReceipt(account) {
      this.newreceipt.subReceipts.push({
        Account: account,
        TransCode: '',
        TransSubCode: '',
        ChargeTransCode: '',
        ChargeTransSubCode: '',
        PropertyOwner: true,
        PropertyReconnection: false,
        PropertyId: 0,
        ReceiptAmount: 0,
        ChequeBankId: '',
        ChequeNo: '',
        ChequeDetails: '',
        Remarks1: '',
        Remarks2: '',
        DmCaseId: 0,
        AgreemNo: 0,
        ApplicationId: 0,
        ActivityId: 0
      });
    },
    selectedSubReceiptClass(idx) {
      return Number(idx) === Number(this.selectedSubReceiptIdx) ? 'selectSubReceipt' : '';
    },
    onSubReceiptSelect(idx) {
      this.selectedSubReceiptIdx = Number(idx); //(this.newreceipt.subReceipts.indexOf(item));

      this.transactionType =
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransCode +
        '-' +
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransSubCode;
      this.selectedSubReceipt = this.newreceipt.subReceipts[this.selectedSubReceiptIdx];
      this.applicationType = this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ApplicationId;
    },
    addTransaction() {
      var tt = this.transactionTypes[0];

      this.newreceipt.subReceipts.push({
        Account: this.customer.account,
        TransCode: tt.transCode,
        TransSubCode: tt.transSubCode,
        ChargeTransCode: tt.chargeTransCode,
        ChargeTransSubCode: tt.chargeTransSubCode,
        PropertyOwner: true,
        PropertyReconnection: false,
        PropertyId: this.properties.length > 0 ? this.properties[0].propertyId : null,
        ReceiptAmount: 0,
        ChequeBankId: '',
        ChequeNo: '',
        ChequeDetails: '',
        Remarks1: '',
        Remarks2: '',
        DmCaseId: 0,
        AgreemNo: 0,
        ApplicationId: 0,
        ActivityId: 0
      });

      this.selectedSubReceiptIdx = this.newreceipt.subReceipts.length - 1;
      this.transactionType =
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransCode +
        '-' +
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransSubCode;
      this.selectedSubReceipt = this.newreceipt.subReceipts[this.selectedSubReceiptIdx];
      this.applicationType = this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ApplicationId;
    },
    showDeleteTransConfirmation(index) {
      if (this.newreceipt.subReceipts.length == 1) {
        this.$alertMsg(this.$t('receipting.deleteTransactionWarning'));
        return;
      }

      this.deleteTransIndex = index;
      this.deleteTransMessage =
        this.$t('receipting.deleteTransMessage') +
        '<br>' +
        this.transactionTypes.filter(
          (a) =>
            a.transCode == this.newreceipt.subReceipts[this.deleteTransIndex].TransCode &&
            a.transSubCode == this.newreceipt.subReceipts[this.deleteTransIndex].TransSubCode
        )[0].name +
        '<br>' +
        this.$t('receipting.amount') +
        ': ' +
        this.newreceipt.subReceipts[this.deleteTransIndex].ReceiptAmount;
      this.deleteTransShowConfirm = true;
    },
    deleteTransaction() {
      this.newreceipt.subReceipts.splice(this.deleteTransIndex, 1);

      this.selectedSubReceiptIdx = 0;
      this.transactionType =
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransCode +
        '-' +
        this.newreceipt.subReceipts[this.selectedSubReceiptIdx].TransSubCode;
      this.selectedSubReceipt = this.newreceipt.subReceipts[this.selectedSubReceiptIdx];
      this.applicationType = this.newreceipt.subReceipts[this.selectedSubReceiptIdx].ApplicationId;

      this.runningTotal = 0;

      for (var i = 0; i < this.newreceipt.subReceipts.length; i++) {
        this.runningTotal += Number(this.newreceipt.subReceipts[i].ReceiptAmount);
      }
    },
    validateReceiptingTab() {
      this.$v.newreceipt.subReceipts.$touch();

      if (!this.$v.newreceipt.subReceipts.$invalid) {
        this.doneReceipting();
      }
    },
    doneReceipting() {
      if (this.runningTotal == 0) {
        this.$alertMsg(this.$t('receipting.amountToBePaidNotSpecified'));
        return;
      }

      this.setDone('stepReceipting', 'stepPaymentProcessing');
    },
    calcOverAmount() {
      if (this.settings.overAmountCharges == false) {
        return;
      }

      this.cashPaidAmount = Number(this.cashPaidAmount);
      this.newreceipt.cashAmount = this.cashPaidAmount - Number(this.change);
      this.newreceipt.chequeAmount = Number(this.newreceipt.chequeAmount);
      this.newreceipt.postalAmount = Number(this.newreceipt.postalAmount);

      for (var i = 0; i < this.newreceipt.subReceipts.length; i++) {
        this.newreceipt.subReceipts[i].TransCode = Number(this.newreceipt.subReceipts[i].TransCode);
        this.newreceipt.subReceipts[i].TransSubCode = Number(this.newreceipt.subReceipts[i].TransSubCode);
        this.newreceipt.subReceipts[i].ChargeTransCode = Number(this.newreceipt.subReceipts[i].ChargeTransCode);
        this.newreceipt.subReceipts[i].ChargeTransSubCode = Number(this.newreceipt.subReceipts[i].ChargeTransSubCode);
        this.newreceipt.subReceipts[i].PropertyId = this.newreceipt.subReceipts[i].PropertyId == null ? 0 : this.newreceipt.subReceipts[i].PropertyId;
      }

      axios
        .post('/Receipting/GetOverAmount', this.newreceipt)
        .then((response) => {
          if (response.status == 200) {
            this.overAmount.cash = response.data.overAmountCash;
            this.overAmount.cheque = response.data.overAmountCheque;
            this.overAmount.creditCard = response.data.overAmountCreditCard;
            this.overAmount.total = response.data.overAmountCash + response.data.overAmountCheque + response.data.overAmountCreditCard;

            this.newreceipt.overAmount = response.data.overAmountCash + response.data.overAmountCheque + response.data.overAmountCreditCard;

            this.totalAmountToPay.cash = (Number(this.cashPaidAmount) + Number(response.data.overAmountCash)).toFixed(3);
            this.totalAmountToPay.cheque = (Number(this.newreceipt.chequeAmount) + Number(response.data.overAmountCheque)).toFixed(3);
            this.totalAmountToPay.creditCard = (Number(this.newreceipt.postalAmount) + Number(response.data.overAmountCreditCard)).toFixed(3);
            this.totalAmountToPay.total = (
              Number(this.totalAmountToPay.cash) +
              Number(this.totalAmountToPay.cheque) +
              Number(this.totalAmountToPay.creditCard)
            ).toFixed(3);
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    calcPaidAmount(e) {
      this.amountPaid = 0;
      this.change = 0;

      if (this.chequeEnable == false) this.newreceipt.chequeAmount = 0;

      if (this.creditCardEnable == false) this.newreceipt.postalAmount = 0;

      var cash = this.cashPaidAmount == '' ? 0 : Number(this.cashPaidAmount);
      var cheque = this.chequeEnable == false ? 0 : this.newreceipt.chequeAmount == '' ? 0 : Number(this.newreceipt.chequeAmount);
      var postal = this.creditCardEnable == false ? 0 : this.newreceipt.postalAmount == '' ? 0 : Number(this.newreceipt.postalAmount);

      this.amountPaid = cash;

      if (this.runningTotal >= this.amountPaid) this.change = 0;
      else this.change = this.amountPaid - this.runningTotal;

      this.totalAmountPaid = cash + cheque + postal;

      this.newreceipt.cashAmount = this.cashPaidAmount - Number(this.change);
      this.calcOverAmount();
    },
    validatePaymentTab() {
      this.$v.totalAmountPaid.$touch();
      this.$v.cashPaidAmount.$touch();
      this.$v.newreceipt.chequeAmount.$touch();
      this.$v.newreceipt.postalAmount.$touch();

      if (
        !this.$v.totalAmountPaid.$invalid &&
        !this.$v.cashPaidAmount.$invalid &&
        !this.$v.newreceipt.chequeAmount.$invalid &&
        !this.$v.newreceipt.postalAmount.$invalid
      ) {
        this.saveReceipt();
      }
    },
    saveReceipt() {
      this.cashPaidAmount = Number(this.cashPaidAmount);
      this.newreceipt.cashAmount = this.cashPaidAmount - Number(this.change);
      this.newreceipt.chequeAmount = Number(this.newreceipt.chequeAmount);
      this.newreceipt.postalAmount = Number(this.newreceipt.postalAmount);

      var lang = this.$localStorage.get('_lang');
      var receiptReportId = 0;
      if (lang && lang.length > 0) {
        if (this.receiptReports.filter((a) => a.language == lang && a.isActive).length > 0) {
          receiptReportId = this.receiptReports.filter((a) => a.language == lang && a.isActive)[0].reportId;
        }
      }

      this.newreceipt.reportId = receiptReportId; //this.receiptReports.length == 0 ? 0 : this.receiptReports[0].reportId;

      if (this.newreceipt.cashAmount + this.newreceipt.chequeAmount + this.newreceipt.postalAmount != this.runningTotal) {
        this.$alertMsg(this.$t('receipting.amountToBePaidNotSpecified'));
        return;
      }

      for (var i = 0; i < this.newreceipt.subReceipts.length; i++) {
        this.newreceipt.subReceipts[i].TransCode = Number(this.newreceipt.subReceipts[i].TransCode);
        this.newreceipt.subReceipts[i].TransSubCode = Number(this.newreceipt.subReceipts[i].TransSubCode);
        this.newreceipt.subReceipts[i].ChargeTransCode = Number(this.newreceipt.subReceipts[i].ChargeTransCode);
        this.newreceipt.subReceipts[i].ChargeTransSubCode = Number(this.newreceipt.subReceipts[i].ChargeTransSubCode);
        this.newreceipt.subReceipts[i].PropertyId = this.newreceipt.subReceipts[i].PropertyId == null ? 0 : this.newreceipt.subReceipts[i].PropertyId;
      }

      this.$store.state.notifier.asyncBlock(
        axios.post('/Receipting/SaveReceipt', this.newreceipt),
        (response) => {
          if (response.status == 200) {
            this.resetFilters();
            this.customers = [];
            this.cashPaidAmount = 0;
            this.creditCardEnable = false;
            this.chequeEnable = false;
            this.runningTotal = 0;
            this.saveReceiptDone = true;
            this.totalAmountPaid = 0;

            if (response.data.reportUrl != '') window.open(response.data.reportUrl, '_blank');

            //this.repUrl = response.data.reportUrl;
            //this.elementVisible = true;
            //setTimeout(() => this.elementVisible = false, 2000);

            this.setDone('stepPaymentProcessing', 'stepSelectCustomer');
          }
        },
        (error) => {
          this.$alertMsg(error.response.data);
        },
        'Saving & Printing'
      );
    },
    goToReceipting() {
      this.active = 'stepReceipting';
      this.newreceipt.cashAmount = 0;
      this.newreceipt.chequeAmount = 0;
      this.newreceipt.postalAmount = 0;
      this.amountPaid = 0;
      this.change = 0;

      this.creditCardEnable = false;
      this.chequeEnable = false;
      this.stepPaymentProcessing = false;
      this.stepReceipting = false;
    },
    goToSelectCustomer() {
      this.active = 'stepSelectCustomer';
      this.stepSelectCustomer = false;

      var nxtReceiptNo = (Number(this.session.nextReceiptNo) - 1).toString();

      var zero = '';
      for (var i = 0; i < this.session.fromReceiptNo.length - nxtReceiptNo.length; i++) {
        zero += '0';
      }

      nxtReceiptNo = zero + nxtReceiptNo.toString();

      this.session.nextReceiptNo = nxtReceiptNo;
    },
    onClose(event) {
      this.showDialog = true;
      return;

      if (this.$store.state.curOrder != '') {
        event.preventDefault();
        event.returnValue = 'aaaaaaaa';
      }
    },
    validateCreateNewSession() {
      this.$v.newSession.$touch();

      if (!this.$v.newSession.$invalid) {
        this.createNewSession();
      }
    },
    createNewSession() {
      this.$store.state.notifier.asyncBlock(
        axios.post(
          '/Receipting/CreateNewSession?' +
            'receiptFrom=' +
            Number(this.newSession.startReceiptNo) +
            '&receiptTo=' +
            Number(this.newSession.endReceiptNo) +
            '&moneyFloat=' +
            Number(this.newSession.cashierFloat)
        ),
        (response) => {
          if (response.status == 200) {
            this.session.sessionId = response.data;
            this.active = 'stepSelectCustomer';
            this.newSessionWindow = false;
            this.resumeSessionWindow = false;

            this.newSession.startReceiptNo = '';
            this.newSession.endReceiptNo = '';
            this.newSession.cashierFloat = '0';

            if (this.settings.showCashierReceiptRange) this.getNewSessionParametersForPreview();

            this.getAttachments();

            this.getReceiptReports();
          }
        },
        (error) => {
          this.$alertMsg(error.response.data);
        }
      );
    },
    cancelCreateNewSession() {
      this.$v.newSession.$reset();
      this.newSession.startReceiptNo = '';
      this.newSession.endReceiptNo = '';
      this.newSession.cashierFloat = '0';
      this.newSessionWindow = false;
    },
    getNewSessionParameters() {
      axios
        .post('/Receipting/GetNewSessionParameters')
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.newSession.startReceiptNo = +response.data.receiptFrom;
            this.newSession.endReceiptNo = +response.data.receiptTo;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getNewSessionParametersForPreview() {
      axios
        .post('/Receipting/GetNewSessionParameters')
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.session.fromReceiptNo = response.data.receiptFrom;
            this.session.toReceiptNo = response.data.receiptTo;
            this.active = 'stepSelectCustomer';
            this.newSessionWindow = false;
            this.resumeSessionWindow = false;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    resumeSession() {
      this.session = this.suspendedSession;
      this.active = 'stepSelectCustomer';
      this.newSessionWindow = false;
      this.resumeSessionWindow = false;
      this.getAttachments();
      this.getReceiptReports();
      this.getReceiptingGeneralReports();

      window.addEventListener('beforeunload', this.suspendSession);
    },
    suspendSession() {
      if (this.session.sessionId == -1) return;

      axios
        .post('/Receipting/SuspendSession')
        .then((response) => {
          if (response.status == 200) {
            this.session.sessionId = -1;
            this.active = '';
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    cancelCloseSession() {
      this.showCloseSessionsDialog = false;
      this.closeSession.bankRef = '';
      this.closeSession.totalCash = 0;
      this.closeSession.totalCheques = 0;
      this.closeSession.totalCreditCard = 0;
    },
    closeSessionAction() {
      var cashAmt = this.closeSession.totalCash == '' ? 0 : Number(this.closeSession.totalCash);
      var chequeAmt = this.closeSession.totalCheques == '' ? 0 : Number(this.closeSession.totalCheques);
      var postalAmt = this.closeSession.totalCreditCard == '' ? 0 : Number(this.closeSession.totalCreditCard);

      if (this.settings.bankRefMandatory == true && this.closeSession.bankRef == '') {
        this.$alertMsg(this.$t('receipting.bankRefMandatory'));
        return;
      }

      this.$store.state.notifier.asyncBlock(
        axios.post(
          '/Receipting/CloseSession?' +
            'cashAmount=' +
            cashAmt +
            '&chequeAmount=' +
            chequeAmt +
            '&postalAmount=' +
            postalAmt +
            '&bankRef=' +
            this.closeSession.bankRef
        ),
        (response) => {
          this.showCloseSessionsDialog = false;
          this.session.sessionId = -1;
          this.session.receiptCount = 0;
          this.session.fromReceiptNo = '';
          this.session.toReceiptNo = '';
          this.session.nextReceiptNo = '';
          this.session.isFinalReceipt = false;
          this.active = '';

          this.$alertMsg(this.$t('receipting.receiptingSessionPostedSuccessfully'), 2);
        },
        (error) => {
          this.$alertMsg(error.response.data.message);

          if (error.response.data.forcedClosed) {
            this.$alertMsg(this.$t('receipting.YourAttemptsToCloseTheSessionHaveBeenExhausted'));
            this.showCloseSessionsDialog = false;
            this.session.sessionId = -1;
            this.session.receiptCount = 0;
            this.session.fromReceiptNo = '';
            this.session.toReceiptNo = '';
            this.session.nextReceiptNo = '';
            this.session.isFinalReceipt = false;
            this.active = '';
          }
        }
      );
    },
    cancelVoidReceipt() {
      this.showVoidReceiptDialog = false;
      this.voidReceiptData.receiptNo = '';
      this.voidReceiptData.receiptAmt = 0;
      this.voidReceiptData.comment1 = '';
      this.voidReceiptData.comment2 = '';
    },
    voidReceipt() {
      var receiptAmt = this.voidReceiptData.receiptAmt == '' ? 0 : Number(this.voidReceiptData.receiptAmt);

      this.$store.state.notifier.asyncBlock(
        axios.post(
          '/Receipting/VoidReceipt?' +
            'receiptNo=' +
            this.voidReceiptData.receiptNo +
            '&receiptAmount=' +
            receiptAmt +
            '&comment=' +
            this.voidReceiptData.comment1 +
            '&comment2=' +
            this.voidReceiptData.comment2
        ),
        (response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('receipting.receiptHasBeenVoidedSuccessfully'), 2);
            this.showVoidReceiptDialog = false;
          }
        },
        (error) => {
          this.$alertMsg(error.response.data);
        }
      );
    },
    calcCloseSessionTotalAmount() {
      var cashAmt = this.closeSession.totalCash == '' ? 0 : Number(this.closeSession.totalCash);
      var chequeAmt = this.closeSession.totalCheques == '' ? 0 : Number(this.closeSession.totalCheques);
      var postalAmt = this.closeSession.totalCreditCard == '' ? 0 : Number(this.closeSession.totalCreditCard);

      this.closeSession.totalAmount = cashAmt + chequeAmt + postalAmt;
    },
    cancelReceipt() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/Receipting/CancelReceipt'),
        (response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('receipting.receiptHasBeenCanceledSuccessfully'), 2);
            this.createNewReceipt();
            this.showCancelReceiptDialog = false;
          }
        },
        (error) => {
          this.$alertMsg(error.response.data);
        }
      );
    },

    getReceiptReports() {
      axios
        .get('/Receipting/GetReceiptReports')
        .then((response) => {
          this.receiptReports = response.data;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getReceiptingGeneralReports() {
      axios
        .get('/Receipting/GetReceiptingGeneralReports')
        .then((response) => {
          this.generalReports = response.data;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    createReceiptingGeneralReport(reportId) {
      axios
        .post('/Receipting/CreateReceiptingGeneralReport?reportId=' + reportId)
        .then((response) => {
          window.open(response.data, '_blank');
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    tabsPaymentAttachmentsChanged(id) {
      this.paymantAttachmentsActiveTab = id;
    },

    getAttachments() {
      axios
        .post('/Receipting/GetAttachments')
        .then((response) => {
          this.attachments = response.data;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    onAttachmentSelect(items) {
      this.selectedAttachments = items;
    },
    addDays(date, days) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getUTCDate();

        date.setUTCMonth(date.getUTCMonth() + count, 1);
        m = date.getUTCMonth();
        date.setUTCDate(d);
        if (date.getUTCMonth() !== m) date.setUTCDate(0);
      }
      return date;
    },
    addMonths(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getDate();

        date.setMonth(date.getMonth() + count, 1);
        m = date.getMonth();
        date.setDate(d);
        if (date.getMonth() !== m) date.setDate(0);
      }
      return date;
    },
    formatDateUI(date) {
      return moment(date).add(1, 'days').format(uiDateFormat);
    },
    roundNumberV2(value, decimals) {
      return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
    },
    roundNumberV1(num, scale) {
      var arr = ('' + num).split('e');
      var sig = '';
      if (+arr[1] + scale > 0) {
        sig = '+';
      }
      var i = +arr[0] + 'e' + sig + (+arr[1] + scale);
      var j = Math.round(Number(i));
      var k = +(j + 'e-' + scale);
      return k;
    },

    showCloseDialog() {
      this.closeSession.totalCash = 0;
      this.closeSession.totalCheques = 0;
      this.closeSession.totalCreditCard = 0;

      this.showCloseSessionsDialog = true;
    },
    getReceiptCopyReports() {
      axios
        .get('/Receipting/GetReceiptCopyReports')
        .then((response) => {
          if (response.status == 200) {
            this.receiptCopyReports = response.data;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    printCopy(repId) {
      if (this.printCopyReceiptNo == '') return;

      axios
        .post('/Receipting/CreateReceiptCopyReport?reportId=' + repId + '&receiptNo=' + this.printCopyReceiptNo)
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
            /*this.repUrl = response.data;
            this.elementVisible = true;
            setTimeout(() => this.elementVisible = false, 2000);*/
            this.showReceiptCopyReports = false;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getQueries() {
      if (this.offlineModeState) return;

      axios
        .get('/CustomQuery/GetQueries?locationId=7')
        .then((response) => {
          if (response.status == 200) {
            if (response.data == null) this.queries = [];
            else this.queries = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        });
    }
  }
};
